// Procedural pixel-art textures generated at boot time.

export function buildTextures(scene) {
  const g = scene.add.graphics();

  // 1×1 white pixel — used for particles, stars, hp bars.
  g.clear();
  g.fillStyle(0xffffff, 1);
  g.fillRect(0, 0, 1, 1);
  g.generateTexture('px', 1, 1);

  // soft glow disc
  g.clear();
  for (let r = 12; r > 0; r--) {
    g.fillStyle(0xffffff, (12 - r) / 60);
    g.fillCircle(16, 16, r);
  }
  g.generateTexture('glow', 32, 32);

  drawPlayer(g);   g.generateTexture('player', 28, 28);

  // player bullet
  g.clear();
  g.fillStyle(0xffffff, 1);
  g.fillRect(2, 0, 4, 12);
  g.fillStyle(0x66ddff, 1);
  g.fillRect(1, 1, 6, 10);
  g.fillStyle(0xffffff, 1);
  g.fillRect(3, 0, 2, 6);
  g.generateTexture('bullet', 8, 12);

  // enemy bullet
  g.clear();
  g.fillStyle(0xff6688, 1);
  g.fillCircle(5, 5, 5);
  g.fillStyle(0xffffff, 1);
  g.fillCircle(5, 5, 2);
  g.generateTexture('ebullet', 10, 10);

  // missile
  g.clear();
  g.fillStyle(0xffeecc, 1);
  g.fillRect(3, 0, 4, 14);
  g.fillStyle(0xff7799, 1);
  g.fillRect(2, 2, 6, 10);
  g.fillStyle(0xffaa55, 1);
  g.fillRect(0, 10, 2, 4);
  g.fillRect(8, 10, 2, 4);
  g.generateTexture('missile', 10, 14);

  // drone
  g.clear();
  g.fillStyle(0xb19cff, 1);
  g.fillCircle(8, 8, 7);
  g.fillStyle(0xffffff, 1);
  g.fillCircle(8, 8, 3);
  g.fillStyle(0xddccff, 1);
  g.fillRect(0, 7, 16, 2);
  g.generateTexture('drone', 16, 16);

  drawGrunt(g);   g.generateTexture('e_grunt', 20, 20);
  drawSwarm(g);   g.generateTexture('e_swarm', 14, 14);
  drawTank(g);    g.generateTexture('e_tank', 30, 30);
  drawShooter(g); g.generateTexture('e_shooter', 22, 22);
  drawDiver(g);   g.generateTexture('e_diver', 18, 18);
  drawDrifter(g); g.generateTexture('e_drifter', 24, 24);

  drawMothership(g); g.generateTexture('b_mothership', 80, 60);
  drawHivemind(g);   g.generateTexture('b_hivemind', 80, 70);

  drawGem(g, 0x66ddff);      g.generateTexture('gem_s', 8, 8);
  drawGem(g, 0x77ff88, 1.4); g.generateTexture('gem_m', 12, 12);
  drawGem(g, 0xffcc44, 1.8); g.generateTexture('gem_l', 16, 16);

  // credit pickup
  g.clear();
  g.fillStyle(0xffd755, 1);
  g.fillCircle(6, 6, 5);
  g.fillStyle(0xfff2a8, 1);
  g.fillCircle(6, 6, 3);
  g.fillStyle(0xa37700, 1);
  g.fillRect(5, 3, 2, 6);
  g.fillRect(3, 5, 6, 2);
  g.generateTexture('credit', 12, 12);

  // heal pickup
  g.clear();
  g.fillStyle(0xff5566, 1);
  g.fillRect(0, 4, 12, 4);
  g.fillRect(4, 0, 4, 12);
  g.fillStyle(0xffffff, 1);
  g.fillRect(1, 5, 10, 2);
  g.fillRect(5, 1, 2, 10);
  g.generateTexture('heal', 12, 12);

  // magnet pickup
  g.clear();
  g.fillStyle(0xff88ff, 1);
  g.fillRect(0, 0, 4, 10);
  g.fillRect(8, 0, 4, 10);
  g.fillStyle(0xffffff, 1);
  g.fillRect(0, 0, 4, 3);
  g.fillRect(8, 0, 4, 3);
  g.generateTexture('magnet', 12, 12);

  // stars
  g.clear();
  g.fillStyle(0xffffff, 1);
  g.fillRect(0, 0, 4, 4);
  g.generateTexture('star_s', 4, 4);
  g.clear();
  g.fillStyle(0xffffff, 1);
  g.fillRect(0, 0, 2, 2);
  g.generateTexture('star_xs', 2, 2);

  g.destroy();
}

function drawPlayer(g) {
  g.clear();
  g.fillStyle(0x223047, 1);
  g.fillRect(8, 4, 12, 18);
  g.fillRect(2, 14, 24, 6);
  g.fillStyle(0x66ddff, 1);
  g.fillRect(12, 6, 4, 6);
  g.fillStyle(0x88ccff, 1);
  g.fillRect(8, 4, 12, 2);
  g.fillStyle(0xff7755, 1);
  g.fillRect(10, 22, 2, 4);
  g.fillRect(16, 22, 2, 4);
  g.fillStyle(0x88aaff, 1);
  g.fillRect(0, 16, 2, 4);
  g.fillRect(26, 16, 2, 4);
}

function drawGrunt(g) {
  g.clear();
  g.fillStyle(0x66ff88, 1);
  g.fillRect(2, 0, 16, 4);
  g.fillRect(0, 4, 20, 4);
  g.fillRect(4, 8, 12, 4);
  g.fillRect(2, 12, 4, 4);
  g.fillRect(14, 12, 4, 4);
  g.fillRect(0, 16, 4, 4);
  g.fillRect(16, 16, 4, 4);
  g.fillStyle(0x113322, 1);
  g.fillRect(6, 4, 2, 2);
  g.fillRect(12, 4, 2, 2);
}

function drawSwarm(g) {
  g.clear();
  g.fillStyle(0xffff88, 1);
  g.fillRect(4, 0, 6, 4);
  g.fillRect(2, 4, 10, 4);
  g.fillRect(0, 8, 4, 4);
  g.fillRect(10, 8, 4, 4);
  g.fillStyle(0x664400, 1);
  g.fillRect(5, 5, 1, 1);
  g.fillRect(8, 5, 1, 1);
}

function drawTank(g) {
  g.clear();
  g.fillStyle(0xff8844, 1);
  g.fillRect(2, 0, 26, 6);
  g.fillRect(0, 6, 30, 12);
  g.fillRect(4, 18, 22, 6);
  g.fillRect(8, 24, 14, 6);
  g.fillStyle(0xffcc88, 1);
  g.fillRect(4, 2, 22, 2);
  g.fillStyle(0x442200, 1);
  g.fillRect(8, 10, 4, 4);
  g.fillRect(18, 10, 4, 4);
  g.fillStyle(0xffffff, 1);
  g.fillRect(9, 11, 1, 1);
  g.fillRect(19, 11, 1, 1);
}

function drawShooter(g) {
  g.clear();
  g.fillStyle(0xff66ff, 1);
  g.fillRect(8, 0, 6, 4);
  g.fillRect(4, 4, 14, 4);
  g.fillRect(0, 8, 22, 8);
  g.fillRect(4, 16, 4, 4);
  g.fillRect(14, 16, 4, 4);
  g.fillStyle(0xffffff, 1);
  g.fillRect(9, 10, 2, 2);
  g.fillRect(11, 10, 2, 2);
  g.fillStyle(0x882288, 1);
  g.fillRect(10, 18, 2, 4);
}

function drawDiver(g) {
  g.clear();
  g.fillStyle(0xff5555, 1);
  g.fillRect(7, 0, 4, 4);
  g.fillRect(5, 4, 8, 4);
  g.fillRect(3, 8, 12, 6);
  g.fillRect(0, 12, 4, 4);
  g.fillRect(14, 12, 4, 4);
  g.fillStyle(0xffaa88, 1);
  g.fillRect(7, 10, 4, 2);
}

function drawDrifter(g) {
  g.clear();
  g.fillStyle(0x99aaff, 1);
  g.fillRect(0, 4, 24, 12);
  g.fillRect(2, 2, 20, 2);
  g.fillRect(2, 16, 20, 2);
  g.fillStyle(0xccddff, 1);
  g.fillRect(4, 4, 16, 2);
  g.fillStyle(0x223355, 1);
  g.fillRect(6, 8, 4, 4);
  g.fillRect(14, 8, 4, 4);
}

function drawMothership(g) {
  g.clear();
  g.fillStyle(0xff3366, 1);
  g.fillRect(8, 4, 64, 12);
  g.fillRect(4, 12, 72, 24);
  g.fillRect(12, 36, 56, 12);
  g.fillRect(20, 48, 40, 8);
  g.fillStyle(0xffaaaa, 1);
  g.fillRect(8, 14, 64, 2);
  g.fillStyle(0xffffff, 1);
  g.fillRect(20, 22, 8, 6);
  g.fillRect(36, 22, 8, 6);
  g.fillRect(52, 22, 8, 6);
  g.fillStyle(0x550022, 1);
  g.fillRect(22, 24, 4, 4);
  g.fillRect(38, 24, 4, 4);
  g.fillRect(54, 24, 4, 4);
  g.fillStyle(0x331122, 1);
  g.fillRect(26, 54, 4, 6);
  g.fillRect(50, 54, 4, 6);
}

function drawHivemind(g) {
  g.clear();
  g.fillStyle(0xaa44ff, 1);
  g.fillRect(20, 8, 40, 8);
  g.fillRect(12, 14, 56, 24);
  g.fillRect(8, 38, 64, 10);
  g.fillRect(10, 48, 6, 16);
  g.fillRect(22, 48, 6, 20);
  g.fillRect(36, 48, 8, 22);
  g.fillRect(50, 48, 6, 20);
  g.fillRect(64, 48, 6, 16);
  g.fillStyle(0xffff88, 1);
  g.fillRect(24, 22, 8, 8);
  g.fillRect(48, 22, 8, 8);
  g.fillStyle(0x220033, 1);
  g.fillRect(26, 24, 4, 4);
  g.fillRect(50, 24, 4, 4);
}

function drawGem(g, color, scale = 1) {
  const s = Math.round(8 * scale);
  g.clear();
  g.fillStyle(color, 1);
  const cx = s / 2, cy = s / 2;
  for (let y = 0; y < s; y++) {
    const dy = Math.abs(y - cy);
    const w = Math.max(1, Math.round(s / 2 - dy));
    g.fillRect(Math.round(cx - w), y, w * 2, 1);
  }
  g.fillStyle(0xffffff, 1);
  g.fillRect(cx - 1, 1, 2, 2);
}
